import { useState, useEffect, useCallback } from 'react';
import { getEstimatorAccount } from '../api/commissions';
import type { EstimatorAccount } from '../types/commission';

/**
 * Hook for fetching estimator account summary
 */
export function useEstimatorAccount(userId: number | null) {
  const [data, setData] = useState<EstimatorAccount | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAccount = useCallback(async () => {
    if (!userId) {
      setData(null);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const account = await getEstimatorAccount(userId);
      setData(account);
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to fetch account');
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchAccount();
  }, [fetchAccount]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchAccount,
  };
}
